// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__HBdY-","errorLogs":"EditorFooter_errorLogs__egPj9"};